import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from './Icons';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Hacen entregas fuera de Carrasco?',
    a: 'Coordinamos entregas en distintas zonas de Montevideo. Consúltenos su dirección y lo confirmamos sin problema.'
  }, {
    q: '¿Con cuánta anticipación hay que encargar?',
    a: 'Recomendamos contactarnos con al menos 48–72 horas de anticipación para garantizar la elaboración fresca. Para eventos grandes, antes mejor.'
  }, {
    q: '¿Tienen opciones para dietas especiales?',
    a: 'Trabajamos con elaboración propia, lo que nos permite adaptar opciones. Consúltenos su necesidad específica.'
  }, {
    q: '¿Cómo sé que llegará a tiempo?',
    a: 'Coordinamos el horario de entrega desde el primer contacto y confirmamos el día anterior. Comunicación directa, sin intermediarios.'
  }, {
    q: '¿Es más caro que un catering común?',
    a: 'Nuestros precios reflejan elaboración artesanal real y presentación visual trabajada. La diferencia se nota — y sus invitados también la notan.'
  }, {
    q: '¿Puedo ver fotos de trabajos anteriores?',
    a: 'Por supuesto. Escríbanos y le compartimos portfolio de eventos anteriores.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-cream" data-id="element-120">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <FadeIn className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-6" data-id="element-123">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-124">
          <div className="space-y-4" data-id="element-125">
            {faqs.map((faq, index) => <div key={index} className="bg-warm-white border border-sand rounded-sm overflow-hidden" data-id="element-126">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-127">
                  <span className="font-medium text-deep-brown text-lg pr-8" data-id="element-128">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-129" />
                </button>

                <AnimatePresence data-id="element-130">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-131">
                      <div className="px-6 pb-5 text-brown-medium border-t border-sand/50 pt-4" data-id="element-132">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}